/** Review status keys (see check_review_statuses in records/utils.py) with display names, in display order. */
export const GROUPS: Array<[string, string]> = [
	["phase_I", "Phase I"],
	["phase_I_arch", "Phase I Archaeology"],
	["phase_I_hist", "Phase I Historic Architecture"],
	["phase_II", "Phase II"],
	["phase_II_wetlands", "Phase II Wetlands"],
	["phase_II_non_wetlands", "Phase II Non-wetlands"],
	["request_info", "Request More Information"],
];
